import { useState, useEffect } from "react";
import FileInfo from "components/file-info";
import { useTranslation } from "react-i18next";

export default function FileTree() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasFiles, setHasFiles] = useState(false);
  const [dirInfo, setDirInfo] = useState({});
  const [forceRefresh, setForceRefresh] = useState(0);

  const apiUrl = `http://${window.location.hostname}:3030`;

  useEffect(() => {
    fetch(apiUrl + "/files/")
      .then((res) => res.json())
      .then(
        (result) => {
          result.basename = "All data";
          setDirInfo(result);
          if (result.files.length > 0) {
            setHasFiles(true);
          }
        },
        (error) => {
          console.error("Error getting file list:", error);
          setError(error.message);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  }, [forceRefresh]);

  return (
    <section className="pb-20">
      {error ? (
        <p className="font-medium  text-rose-600">
          {t("file_download.error_message", { 0: error })}
        </p>
      ) : loading ? (
        <p className="text-gray-400">{t("common.loading")}...</p>
      ) : hasFiles ? (
        <>
          <p className="mb-2 text-gray-400">{t("file_download.description")}</p>
          <FileInfo
            info={dirInfo}
            apiUrl={apiUrl}
            setForceRefresh={setForceRefresh}
            initiallyCollapsed={false}
          />
        </>
      ) : (
        <p className=" text-gray-400">{t("file_download.no_data_message")}</p>
      )}
    </section>
  );
}
